import { render, staticRenderFns } from "./Workday.vue?vue&type=template&id=1bace0f1&"
import script from "./Workday.vue?vue&type=script&lang=js&"
export * from "./Workday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports